import { CalendarTheme } from '@marceloterreiro/flash-calendar';

export const calendarTheme: CalendarTheme = {
  itemDay: {
    idle: () => ({
      container: {
        minWidth: 32,
      },
    }),
    today: () => ({
      container: {
        minWidth: 32,
      },
    }),
    active: () => ({
      container: {
        minWidth: 32,
        backgroundColor: '#000',
        borderRadius: 999,
      },
      content: {
        color: '#fff',
      },
    }),
    disabled: () => ({
      container: {
        minWidth: 32,
      },
    }),
  },
};
